// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBEgnMSYxGr8cLKDGGAX32p2_VFY4xLq60",
  authDomain: "terminal-development-f3d57.firebaseapp.com",
  projectId: "terminal-development-f3d57",
  storageBucket: "terminal-development-f3d57.appspot.com",
  messagingSenderId: "329150507598",
  appId: "1:329150507598:web:39a4a628e9542daf0ab11f",
  measurementId: "G-0EQQQ8KQ2Q",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
